import { IAppState } from '../../../../../AppModulesWrapper';
import { createSelector } from 'reselect';
import { selectAuctionBet } from './selectAuctionBet';
import { IAuctionBet } from '../types';

export const selectPreviousBets = createSelector(
  (state: IAppState) => selectAuctionBet(state),
  (auctionBet: IAuctionBet): number[] => {
    return auctionBet.previousBets;
  },
);
